import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-GenericLead" */'shared-components/components/GenericLead'));
